import { render, staticRenderFns } from "./PersonalPropertyForm.vue?vue&type=template&id=a06741d8"
import script from "./PersonalPropertyForm.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyForm.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyForm.vue?vue&type=style&index=0&id=a06741d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports